import { RouteObject } from 'react-router';

import { BusinessDetails } from './Details';
// import { DefaultProductsCard } from './Details/components/DefaultProducts';
import { Employees } from './Details/components/Employees';
import { Financial } from './Details/components/Financial';
import { BusinessInfo } from './Details/components/Info';
// import { PriceTierCard } from './Details/components/PriceTiers';
// import { ProductPriceTierCard } from './Details/components/ProductPriceTiers';
import { BusinessesList } from './List';

export const BUSINESS_ROUTES: RouteObject[] = [
    {
        index: true,
        Component: BusinessesList,
    },
    {
        path: ':id/*',
        Component: BusinessDetails,
        children: [
            { index: true, Component: BusinessInfo },
            { path: 'employees', Component: Employees },
            { path: 'financial', Component: Financial },

            // {
            //     path: 'product-price-tiers',
            //     Component: ProductPriceTierCard,
            // },
            // {
            //     path: 'default-products',
            //     Component: DefaultProductsCard,
            // },

            // {
            //     path: 'price-tiers',
            //     Component: PriceTierCard,
            // },
        ],
    },
];
